import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useCallback, useState } from 'react';
import { string, func } from 'prop-types';
import fullNameMask from '../../utils/fullNameMask';
import emailMask from '../../utils/emailMask';
import Box from '../../atoms/Box';
import Button from '../../atoms/Button';
import Checkbox from '../../atoms/Checkbox';
import Flex from '../../atoms/Flex';
import Link from '../../atoms/Link';
import Text from '../../atoms/Text';
import Input from '../../atoms/Input';
import { Title, Description, InputLabel, ErrorMessage } from './letMeKnow.styles';

function LetMeKnow({
  errorEmail,
  errorName,
  labelEmail,
  labelName,
  labelNewsletter,
  noticeMeLabel,
  noticeMeLink,
  onSubmit,
  placeholderEmail,
  placeholderName,
  subtitle,
  textSubmitButton,
  title
}) {
  const [newsletter, setNewsletter] = useState(true);
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});
  const validateFullName = React.useCallback(() => {
    const fullNameError = !fullNameMask(fullName) ? {
      fullName: errorName
    } : undefined;
    setErrors(_ref => {
      let errs = _objectWithoutPropertiesLoose(_ref, ["fullName"]);

      return Object.assign({}, errs, fullNameError);
    });
    return fullNameError;
  }, [fullName]);
  const validateEmail = React.useCallback(_email => {
    const emailError = !emailMask(_email) ? {
      email: errorEmail
    } : undefined;
    setErrors(_ref2 => {
      let errs = _objectWithoutPropertiesLoose(_ref2, ["email"]);

      return Object.assign({}, errs, emailError);
    });
    return emailError;
  }, [email]);
  const clearForm = useCallback(() => {
    setFullName('');
    setEmail('');
    setNewsletter(true);
  }, [fullName, email]);

  const handleSubmit = e => {
    const errs = Object.assign({}, validateFullName(fullName), validateEmail(email));

    if (!Object.entries(errs).length) {
      onSubmit({
        fullName,
        email,
        newsletter
      }, clearForm);
    }

    e.preventDefault();
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "baseline",
    gap: "2",
    mb: "3"
  }, /*#__PURE__*/React.createElement(Title, {
    "data-testid": "let-me-know-title"
  }, title), /*#__PURE__*/React.createElement(Link, {
    href: noticeMeLink,
    target: "_blank",
    underline: true,
    color: "text.light",
    fontSize: [0, 1, 2, 2]
  }, noticeMeLabel)), /*#__PURE__*/React.createElement(Description, {
    "data-testid": "let-me-know-description"
  }, subtitle), /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement(InputLabel, {
    "data-testid": "let-me-know-input-label-name"
  }, labelName), /*#__PURE__*/React.createElement(Input, {
    "data-testid": "let-me-know-input-name",
    placeholder: placeholderName,
    hasError: !!errors.fullName,
    value: fullName,
    onChange: e => setFullName(e.target.value),
    onFocus: () => setErrors(_ref3 => {
      let errs = _objectWithoutPropertiesLoose(_ref3, ["fullName"]);

      return errs;
    }),
    onBlur: e => validateFullName(e.target.value)
  }), /*#__PURE__*/React.createElement(ErrorMessage, {
    "data-testid": "let-me-know-error-name"
  }, errors.fullName), /*#__PURE__*/React.createElement(InputLabel, {
    "data-testid": "let-me-know-input-label-email"
  }, labelEmail), /*#__PURE__*/React.createElement(Input, {
    "data-testid": "let-me-know-input-email",
    placeholder: placeholderEmail,
    type: "email",
    hasError: !!errors.email,
    value: email,
    onChange: e => setEmail(e.target.value),
    onFocus: () => setErrors(_ref4 => {
      let errs = _objectWithoutPropertiesLoose(_ref4, ["email"]);

      return errs;
    }),
    onBlur: e => validateEmail(e.target.value)
  }), /*#__PURE__*/React.createElement(ErrorMessage, {
    "data-testid": "let-me-know-error-email"
  }, errors.email)), /*#__PURE__*/React.createElement(Box, {
    mt: 15
  }, /*#__PURE__*/React.createElement(Checkbox, {
    as: Text,
    fontSize: [1, 2],
    checked: newsletter,
    onChange: e => setNewsletter(e.target.checked)
  }, labelNewsletter)), /*#__PURE__*/React.createElement(Box, {
    mt: 15
  }, /*#__PURE__*/React.createElement(Button, {
    "data-testid": "let-me-know-submit",
    full: true,
    onClick: handleSubmit
  }, textSubmitButton)));
}

LetMeKnow.defaultProps = {
  errorEmail: 'Insira o e-mail corretamente.',
  errorName: 'Insira o nome completo corretamente.',
  labelEmail: 'E-mail',
  labelName: 'Nome',
  labelNewsletter: 'Quero receber ofertas e conteúdos por e-mail',
  noticeMeLabel: 'Ver produtos similares',
  onSubmit: undefined,
  placeholderEmail: 'Digite seu e-mail',
  placeholderName: 'Digite seu nome',
  subtitle: 'Avise-me quando estiver disponível',
  textSubmitButton: 'Avise-me',
  title: 'Não disponível'
};
process.env.NODE_ENV !== "production" ? LetMeKnow.propTypes = {
  errorEmail: string,
  errorName: string,
  labelEmail: string,
  labelName: string,
  labelNewsletter: string,
  newsletter: string,
  noticeMeLabel: string,
  noticeMeLink: string,
  onSubmit: func,
  placeholderEmail: string,
  placeholderName: string,
  subtitle: string,
  textSubmitButton: string,
  title: string
} : void 0;
export default LetMeKnow;